import { type PostContentObjectList, type UploadedFile, createPostContentObjectList } from 'models';
import { useMutation } from 'query';
import { updatePost } from '../../services';
import { useContentObjectCache } from '../cache';

type CreatePostData = {
  attachments?: UploadedFile[];
  communityId?: string;
  htmlContent: string;
  id: string;
  pinned?: boolean;
  textContent: string;
};

export const useUpdatePostMutation = () => {
  const cache = useContentObjectCache();

  return useMutation<PostContentObjectList, CreatePostData>({
    async mutationFn({ attachments, communityId, htmlContent, id, pinned, textContent }) {
      const response = await updatePost({
        body: {
          post: {
            attachments: attachments?.map((attachment) => ({
              id: attachment.id,
            })),
            community_id: communityId,
            html_content: htmlContent,
            pinned,
            text_content: textContent,
          },
        },
        routeParams: {
          id,
        },
      });

      return createPostContentObjectList(response.data);
    },

    onSuccess(data) {
      // TODO: they should be in one function
      cache.replace(data);
      cache.syncPinnedFeeds(data);
    },
  });
};
